module.exports = __webpack_public_path__ + "img/clock-icon.3b626fa3.svg";